export default __webpack_public_path__ + "a3f4e2cae5a69ed9e4aeb6500ed0ab14.png";